import Text8 from './Text8'
export default Text8
